import {Controller} from '@hotwired/stimulus'

export default class extends Controller {
  connect () {
    // Find the form element
    this.form = this.element.querySelector('form')

    if (!this.form) {
      console.error('Form element not found in season-form controller')
    }
  }

  submitForm (event) {
    event.preventDefault()

    // Check if TOTP verification is needed
    const currentAdminHasTotp = this.element.dataset.currentAdminTotpEnabled === 'true'

    if (currentAdminHasTotp) {
      this.showTotpModal()
    } else {
      this.submitFormDirectly()
    }
  }

  showTotpModal () {
    const formData = this.getRawFormData()

    const event = new CustomEvent('showTotpModal', {
      detail: {
        actionUrl: this.getActionUrl(),
        actionMethod: this.getActionMethod(),
        formData: formData
      }
    })
    document.dispatchEvent(event)
  }

  submitFormDirectly () {
    if (this.form) {
      this.form.submit()
    } else {
      console.error('Form element not found')
    }
  }

  getRawFormData () {
    if (!this.form) {
      console.error('Form element not found')
      return new FormData()
    }
    return new FormData(this.form)
  }

  getActionUrl () {
    if (!this.form) {
      console.error('Form element not found')
      return ''
    }
    return this.form.action
  }

  getActionMethod () {
    if (!this.form) {
      console.error('Form element not found')
      return 'PATCH'
    }
    // For Rails forms, check the _method field or use PATCH for updates
    const methodField = this.form.querySelector('input[name="_method"]')
    if (methodField) {
      return methodField.value.toUpperCase()
    }
    if (this.form.method) {
      return this.form.method.toUpperCase()
    }
    return 'PATCH'
  }
}
